module.exports = __webpack_public_path__ + "assets/date-0240c0.svg";